<ng-container *ngIf="form">
    <app-url-form *ngIf="form" [form]="form"></app-url-form>
</ng-container>
